import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { SharedService } from '../../../../Services/shared.service';
import { CommonModule } from '@angular/common';
import { API_End_Point } from '../../../../Services/API_End_Point';
import { GetPdfIdPipe } from '../../../../Services/pipes/get-pdf-id.pipe';
import { FormsModule } from '@angular/forms';
import { distinctUntilChanged } from 'rxjs';

@Component({
  selector: 'app-book-details',
  standalone: true,
  imports: [RouterModule, CommonModule, GetPdfIdPipe, FormsModule],
  templateUrl: './book-details.component.html',
  styleUrl: './book-details.component.css',
})
export class BookDetailsComponent implements OnInit {
  listBookDetails: any[] = [];
  FYearList: string[] = [];
  selectedYear: string = '';
  bookType = 0;
  PREP_UserInfo: any = null;

  constructor(private route: ActivatedRoute, public _svc: SharedService) {
    this.FYearList = this._svc.FYearList();
    this.selectedYear = this._svc.FYear();
    this._svc.get_Login_Status().subscribe((x) => {
      this.PREP_UserInfo = x;
    });
  }

  ngOnInit(): void {
    this.route.queryParamMap.subscribe((params) => {
      this.bookType = Number(params.get('booktype') ?? '0');
      debugger;
      this.fetchBooks();
    });
  }

  onYearChange(): void {
    this.fetchBooks();
  }

  fetchBooks(): void {
    debugger;
    this._svc
      .GET(
        API_End_Point.BookDetailsByBookTypes(
          this.PREP_UserInfo.userId,
          this.selectedYear,
          this.bookType,
          Number(this.PREP_UserInfo.classId)
        )
      )
      .subscribe((res: any) => {
        this.listBookDetails = res.data || [];
        this.route.queryParamMap.subscribe((params) => {
          var bname = params.get('bname');
          if (bname != null) {
            this.listBookDetails = this.listBookDetails.filter(
              (x) => x.title == bname
            );
          }
        });
        console.log(this.listBookDetails);
      });
  }

  get onlyPlan2(): boolean {
    return (
      this.listBookDetails?.length > 0 && this.listBookDetails.every((x: any) => x.plan > 3 || x.plan <= 2)
    );
  }
}
